var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgMoveIcon = function SvgMoveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.695 7.344a.86.86 0 010 1.312l-2.96 2.649c-.407.36-.735.21-.735-.336V9.5H9.5V12h1.469c.547 0 .695.328.336.734l-2.649 2.961a.86.86 0 01-1.312 0l-2.649-2.96c-.36-.407-.21-.735.336-.735H6.5V9.5H4v1.469c0 .547-.328.695-.734.336L.305 8.656a.86.86 0 010-1.312l2.96-2.649c.407-.36.735-.21.735.336V6.5h2.5V4H5.031c-.547 0-.695-.328-.336-.734L7.344.305a.86.86 0 011.312 0l2.649 2.96c.36.407.21.735-.336.735H9.5v2.5H12V5.031c0-.547.328-.695.734-.336l2.961 2.649z",
    fill: "currentColor"
  })));
};
export default SvgMoveIcon;